import {Box, InputAdornment, Skeleton, SxProps, TextField} from '@mui/material';
import {forwardRef} from 'react';
import {Control, Controller, FieldValues, Path} from 'react-hook-form';
import { commonTextFieldProps } from './textfield';

type TextInputFieldProps<T extends FieldValues> = {
	// Identification and Control
	control: Control<T>;
	id: string;
	name: Path<T>;

	// Field Type and Behavior
	disabled?: boolean;
	maxRows?: number;
	minRows?: number;
	multiline?: boolean;
	onChange?: (value: string | undefined) => void;
	required?: boolean;
	row?: number;
	type: 'text';
    maxLength?: number;


	// Styling and Display
	filled?: boolean;
	fullWidth?: boolean;
	label?: string;
	showSkeleton?: boolean;
    slotProps?: {
        startAdornment?: React.ReactNode;
        endAdornment?: React.ReactNode;
        inputProps?: object;
      };
	sx?: SxProps;
};

export const ContactNumberTextField = forwardRef(function TextInputField<
	T extends FieldValues,
>(
	{
		control,
		id,
		name,
		disabled = false,
		onChange,
		required = false,
		filled = false,
		fullWidth = false,
		label,
		showSkeleton = false,
		slotProps = {},
		sx,
        maxLength,

	}: TextInputFieldProps<T>,
	ref: React.Ref<HTMLInputElement>
) {
	

	return (
		<Controller
			name={name}
			control={control}
			render={({field, fieldState}) => {
				return (
					<TextField
						{...field}
						type="text"
						ref={ref}
						id={id}
						label={label}
						
						required={required}
						disabled={disabled}
						error={!!fieldState.error}
						autoComplete="off"
						helperText={fieldState.error?.message}
						fullWidth={fullWidth}
						sx={commonTextFieldProps}
						value={field.value ?? ''}
						InputProps={{
                            startAdornment: slotProps.startAdornment,
                            endAdornment: slotProps.endAdornment,    
                            inputProps: {
                                maxLength: maxLength,
                            },                
                          }}
						multiline={false}
						onChange={(e) => {
							const numericValue = e.target.value.replace(/\D/g, ''); 
							field.onChange(numericValue);
							if (onChange) {
								onChange(numericValue);
							}
						}}
					/>
				);
			}}
		/>
	);
});
